export default __webpack_public_path__ + "static/media/vitamin.d3eda339.png";